module.exports = __webpack_public_path__ + "static/media/jessie-j.a0c6344e.jpg";